<ng-container *ngIf="computedYScaleMax !== undefined; else noYScaleMax">
  <ngx-charts-bar-vertical
    [results]="chartData"
    [customColors]="customColors"
    [gradient]="gradient"
    [xAxis]="true"
    [yAxis]="true"
    [legend]="showLegend && cardSize === CardSize.LARGE"
    [showYAxisLabel]="false"
    [showXAxisLabel]="false"
    [showGridLines]="true"
    (select)="onSelect($event)"
    [showDataLabel]="true"
    [dataLabelFormatting]="dataLabelFormatting"
    [animations]="true"
    [tooltipDisabled]="false"
    [yScaleMin]="0"
    [yScaleMax]="computedYScaleMax"
    class="w-full h-full"
  ></ngx-charts-bar-vertical>
</ng-container>

<ng-template #noYScaleMax>
  <ngx-charts-bar-vertical
    [results]="chartData"
    [customColors]="customColors"
    [gradient]="gradient"
    [xAxis]="true"
    [yAxis]="true"
    [legend]="showLegend && cardSize === CardSize.LARGE"
    [showYAxisLabel]="false"
    [showXAxisLabel]="false"
    [showGridLines]="true"
    (select)="onSelect($event)"
    [showDataLabel]="true"
    [dataLabelFormatting]="dataLabelFormatting"
    [animations]="true"
    [tooltipDisabled]="false"
    [yScaleMin]="0"
    class="w-full h-full"
  ></ngx-charts-bar-vertical>
</ng-template>
